import { useEffect, useState } from "react";
import GlobalContactWhatsappFormLanding from "~/components/global/GlobalContactWhatsappFormLanding";
const selectedImages = [
  "https://ik.imagekit.io/didigi/didigi/JASA-RENOVASI-bangunrumahkita/bangunrumahkita_jasa-renovasi-di-bekasi-banner-1.webp",
  "https://ik.imagekit.io/didigi/didigi/JASA-RENOVASI-bangunrumahkita/bangunrumahkita_jasa-renovasi-di-bekasi-banner-3.webp",
  "https://ik.imagekit.io/didigi/didigi/JASA-RENOVASI-bangunrumahkita/bangunrumahkita_jasa-renovasi-di-bekasi-banner-2.webp",
];

export const JasaBangunRumahDiBekasiSect1TopBanner = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % selectedImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const opacity = Math.max(1 - scrollY / 400, 0);
  const scale = Math.max(1 - scrollY / 1000, 0.4);

  return (
    <div
      className="relative w-full h-[100vh] overflow-hidden mx-auto"
      style={{
        transform: `scale(${scale})`,
        opacity,
        borderRadius: `${Math.min(scrollY / 1, 1000)}px`,
        transition: "transform 0.1s, opacity 0.1s, border-radius 0.3s",
        maxWidth: scrollY > 50 ? "90%" : "100%",
      }}
    >
      {/* Images with fade */}
      {selectedImages.map((img, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
            index === currentIndex ? "opacity-100 z-10" : "opacity-0 z-0"
          }`}
        >
          <div
            className="w-full h-full bg-fixed bg-center bg-cover"
            style={{ backgroundImage: `url(${img})` }}
          >
            <div className="w-full h-full bg-black bg-opacity-30 flex items-center justify-center">
              <div className="text-center text-white px-4 max-w-3xl">
                <h1 className="text-4xl md:text-5xl font-bold mb-4">
                  BANGUN RUMAH IMPIAN UNTUK KELUARGA
                </h1>
                <p className="text-lg md:text-xl mb-6">
                  Bangun rumah bukan sekadar proyek, tapi sebuah perjalanan
                  mewujudkan tempat tinggal yang nyaman, aman, dan penuh makna.
                </p>
                <p className="text-lg md:text-xl mb-6">
                  Bebaskan diri Anda dari stres dan kekhawatiran dalam membangun
                  rumah.
                </p>
                <GlobalContactWhatsappFormLanding
                  buttonText="Booking Konsultasi Gratis"
                  classnameButton="py-[2rem] bg-yellow-500"
                  classnameText="text-xl"
                />
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* 👇 Dot indicators - always on top */}
      <div className="pointer-events-auto z-50 absolute bottom-6 left-1/2 -translate-x-1/2 flex space-x-2">
        {selectedImages.map((_, index) => (
          <div
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`cursor-pointer h-3 rounded-full transition-all duration-300 ${
              currentIndex === index ? "bg-black w-8" : "bg-yellow-500 w-3"
            }`}
          ></div>
        ))}
      </div>
    </div>
  );
};
